import styled from "styled-components";

export const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  padding-bottom: 12px;
`;
